import { useGoals } from 'features/goals';
import { useMemo } from 'react';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

export const useCreateSubGoalAllowed = () => {
  const goals = useGoals();

  const filteredSubGoals = useMemo(
    () =>
      goals.filter(
        ({ completedAt, parentIds, excludedFromLimits }) =>
          !excludedFromLimits && parentIds?.length && !completedAt,
      ),
    [goals],
  );

  const { allowed, enforced, limit } = usePremiumFeatureAllowed(
    LimitKeys.SubGoals,
    {
      totalUncompleted: filteredSubGoals.length,
    },
  );

  return {
    allowed,
    enforced,
    limit,
    total: filteredSubGoals.length,
  };
};
